import { DateHelper } from '../../../../../helpers/date.helper';
import { TrafficSituationHelper } from '../../../../../helpers/traffic-situation.helper';
import { ITrafficSituation } from '../../../../../models/traffic-situation.model';
import { IconMotif } from '../../../../Shared/Icon/icon-motif.enum';
import Fact from '../../../../Shared/Fact';
import './style.scss';
import { ValidityPeriodFactHelper } from './validity-period-fact.helper';
import { t } from '../../../../../services/texts.service';
import { type DateTime } from 'luxon';

export default function ValidityPeriodFact({ trafficSituation, className = '' }: { trafficSituation: ITrafficSituation; className?: string }) {
  if (!ValidityPeriodFactHelper.hasRegularValidityPeriod(trafficSituation)) return null;

  const isPlanned = TrafficSituationHelper.isPlannedTrafficSituation(trafficSituation);
  const startAndEndTimesAreInSameYear = trafficSituation.startTime && trafficSituation.endTime && DateHelper.isSameYear(trafficSituation.startTime, trafficSituation.endTime);

  const renderDate = (date: DateTime) => (
    <time dateTime={date.toISODate() ?? undefined}>
      <span className="visually-hidden">{DateHelper.formatAsLongDate(date, !startAndEndTimesAreInSameYear)}</span>
      <span aria-hidden="true">{DateHelper.formatAsAbbreviatedLongDate(date, !startAndEndTimesAreInSameYear)}</span>
    </time>
  );

  return (
    <Fact iconMotif={isPlanned ? IconMotif.CalendarWithArrow : IconMotif.Calendar} className={className} altText={t('Giltighetstid', 'Validity period')}>
      <div className="validity-period-fact-grid">
        {isPlanned && (
          <>
            <div className="fw-bold" style={{ gridColumn: '1 / -1' }}>
              {t('Planerad', 'Planned')}:{' '}
            </div>
          </>
        )}
        {trafficSituation.startTime && (
          <>
            <div className="fw-bold">{t.from}:</div>
            {renderDate(trafficSituation.startTime)}
          </>
        )}
        <div className="fw-bold">{t.to}:</div>
        {trafficSituation.endTime ? renderDate(trafficSituation.endTime) : <span>{t('tills vidare', 'until further notice')}</span>}
      </div>
    </Fact>
  );
}
